<svelte:options runes={false} />

<script>
  import ProjectDirectory from '../components/ProjectDirectory.svelte';
  import ProjectPolicyForm from '../components/ProjectPolicyForm.svelte';
  import RouteState from '../components/RouteState.svelte';
  import SectionHeading from '../components/SectionHeading.svelte';

  export let operatorMembership;
  export let settingsProject;
  export let projectName;
  export let savingProjectName;
  export let savingProjectPolicy;
  export let onSaveProjectName;
  export let instanceMode;
  export let projectCurrency;
  export let settlementCadence;
  export let processorFeeQuotePolicyId;
  export let transferTax;
  export let showPaymentProgressPercent;
  export let payerFeeShareBps;
  export let operatorFeeShareBps;
  export let onChangeProjectCurrency;
  export let onSavePolicy;
  export let onBack;

  $: canManage = ['owner', 'admin'].includes(operatorMembership?.role);
</script>

<section class="panel operator-settings-panel">
  <SectionHeading eyebrow="Operator" title={settingsProject ? `${settingsProject.name} settings` : 'Project settings'}>
    <svelte:fragment slot="trailing">
      <button type="button" on:click={onBack}>‹ Back to project</button>
    </svelte:fragment>
  </SectionHeading>

  {#if canManage}
    <ProjectDirectory
      selectedProject={settingsProject}
      bind:projectName
      {savingProjectName}
      {onSaveProjectName}
    />
  {/if}

  {#if settingsProject && canManage}
    <ProjectPolicyForm
      {instanceMode}
      {projectCurrency}
      {savingProjectPolicy}
      {onChangeProjectCurrency}
      bind:settlementCadence
      bind:processorFeeQuotePolicyId
      bind:transferTax
      bind:showPaymentProgressPercent
      bind:payerFeeShareBps
      bind:operatorFeeShareBps
      onSave={onSavePolicy}
    />
  {:else}
    <RouteState routeKey="operatorProjectSettings" state="empty" bare onAction={onBack} />
  {/if}
</section>
